// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditWishListGroupForm-marginLeft-noD7K {
    margin-left: 12px;
}

@media screen and (max-width: 767px) {
    .EditWishListGroupForm-mobileBtn-deLG6 {
        width: 100%;
    }

    .EditWishListGroupForm-marginLeft-noD7K {
        margin-left: 0;
        margin-top: 12px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/WishLists/EditWishListGroupForm/EditWishListGroupForm.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,cAAc;QACd,gBAAgB;IACpB;AACJ","sourcesContent":[".marginLeft {\n    margin-left: 12px;\n}\n\n@media screen and (max-width: 767px) {\n    .mobileBtn {\n        width: 100%;\n    }\n\n    .marginLeft {\n        margin-left: 0;\n        margin-top: 12px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"marginLeft": `EditWishListGroupForm-marginLeft-noD7K`,
	"mobileBtn": `EditWishListGroupForm-mobileBtn-deLG6`
};
module.exports = ___CSS_LOADER_EXPORT___;
